export enum ExpertReviewViewTypes {
  PROS_CONS = 'Pros-Cons-Review',
  TEXT = 'Text-Review',
}
